export const cloudInsightsColumns = {
  // Custom columns (these fields don't exist on the /events response object)
  // Used to format data for default columns
  connector: 'connector',
  expandButton: 'expandButton',
  identity: 'identity',

  // Columns (these fields exist on the /events response object)
  accountId: 'accountId',
  eventName: 'eventName',
  eventTime: 'eventTime',
  jumpcloudUser: 'jumpcloudUser',
  nonPersonEntity: 'nonPersonEntity',
  ssoUser: 'ssoUser',
  event: {
    addendum: 'event.addendum',
    additionalEventData: 'event.additionalEventData',
    apiVersion: 'event.apiVersion',
    awsRegion: 'event.awsRegion',
    edgeDeviceDetails: 'event.edgeDeviceDetails',
    errorCode: 'event.errorCode',
    errorMessage: 'event.errorMessage',
    eventCategory: 'event.eventCategory',
    eventId: 'event.eventId',
    eventSource: 'event.eventSource',
    eventType: 'event.eventType',
    eventVersion: 'event.eventVersion',
    managementEvent: 'event.managementEvent',
    recipientAccountId: 'event.recipientAccountId',
    responseElements: 'event.responseElements',
    resources: 'event.resources',
    resourcesArn: 'event.resources.ARN',
    resourcesArnPrefix: 'event.resources.ARNPrefix',
    resourcesAccountId: 'event.resources.accountId',
    resourcesType: 'event.resources.type',
    readOnly: 'event.readOnly',
    requestId: 'event.requestId',
    requestParameters: 'event.requestParameters',
    serviceEventDetails: 'event.serviceEventDetails',
    sessionCredentialFromConsole: 'event.sessionCredentialFromConsole',
    sharedEventId: 'event.sharedEventId',
    sourceIpAddress: 'event.sourceIpAddress',
    tlsDetails: 'event.tlsDetails',
    userAgent: 'event.userAgent',
    userIdentity: {
      type: 'event.userIdentity.type',
      principalId: 'event.userIdentity.principalId',
      arn: 'event.userIdentity.arn',
      accountId: 'event.userIdentity.accountId',
      accessKeyId: 'event.userIdentity.accessKeyId',
      sessionContext: {
        sessionIssuer: {
          arn: 'event.userIdentity.sessionContext.sessionIssuer.arn',
          accountId: 'event.userIdentity.sessionContext.sessionIssuer.accountId',
          principalId: 'event.userIdentity.sessionContext.sessionIssuer.principalId',
          type: 'event.userIdentity.sessionContext.sessionIssuer.type',
          userName: 'event.userIdentity.sessionContext.sessionIssuer.userName',
        },
      },
      invokedBy: 'event.userIdentity.invokedBy',
      userName: 'event.userIdentity.userName',
      identityProvider: 'event.userIdentity.identityProvider',
    },
    vpcEndpointId: 'event.vpcEndpointId',
  },
};

const width = '1fr';

export const columnDataMap = {
  [cloudInsightsColumns.accountId]: {
    dataFieldName: cloudInsightsColumns.accountId,
    label: 'Host AWS Account',
    width: '1fr',
  },
  [cloudInsightsColumns.expandButton]: {
    dataFieldName: cloudInsightsColumns.expandButton,
    label: '',
    width: '3rem',
  },
  [cloudInsightsColumns.eventTime]: {
    dataFieldName: cloudInsightsColumns.eventTime,
    label: 'Date',
    sortable: true,
    width: '5rem',
  },
  [cloudInsightsColumns.connector]: {
    dataFieldName: cloudInsightsColumns.connector,
    label: 'SSO',
    width: '5rem',
  },
  [cloudInsightsColumns.identity]: {
    dataFieldName: cloudInsightsColumns.identity,
    label: 'Identity',
    width: '1fr',
  },
  [cloudInsightsColumns.eventName]: {
    dataFieldName: cloudInsightsColumns.eventName,
    label: 'Action',
    sortable: true,
    width: '0.5fr',
  },
  [cloudInsightsColumns.event.resourcesArn]: {
    dataFieldName: cloudInsightsColumns.event.resourcesArn,
    label: 'Resource',
    width: '1fr',
  },
  [cloudInsightsColumns.event.eventVersion]: {
    dataFieldName: cloudInsightsColumns.event.eventVersion,
    label: 'Event Version',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.userIdentity.type]: {
    dataFieldName: cloudInsightsColumns.event.userIdentity.type,
    label: 'Identity Type',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.userIdentity.principalId]: {
    dataFieldName: cloudInsightsColumns.event.userIdentity.principalId,
    label: 'Principal ID',
    width,
  },
  [cloudInsightsColumns.event.userIdentity.arn]: {
    dataFieldName: cloudInsightsColumns.event.userIdentity.arn,
    label: 'Identity arn',
    width,
  },
  [cloudInsightsColumns.event.userIdentity.accountId]: {
    dataFieldName: cloudInsightsColumns.event.userIdentity.accountId,
    label: 'Identity Account ID',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.userIdentity.accessKeyId]: {
    dataFieldName: cloudInsightsColumns.event.userIdentity.accessKeyId,
    label: 'Access key',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.userIdentity.sessionContext.sessionIssuer]: {
    dataFieldName: cloudInsightsColumns.event.userIdentity.sessionContext.sessionIssuer,
    getJson: (event) => event.event.userIdentity?.sessionContext?.sessionIssuer,
    label: 'Session Issuer',
    width,
  },
  [cloudInsightsColumns.event.userIdentity.invokedBy]: {
    dataFieldName: cloudInsightsColumns.event.userIdentity.invokedBy,
    label: 'Invoked by',
    width,
  },
  [cloudInsightsColumns.event.userIdentity.userName]: {
    dataFieldName: cloudInsightsColumns.event.userIdentity.userName,
    label: 'Username',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.userIdentity.identityProvider]: {
    dataFieldName: cloudInsightsColumns.event.userIdentity.identityProvider,
    label: 'Identity Provider',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.eventSource]: {
    dataFieldName: cloudInsightsColumns.event.eventSource,
    label: 'Event source',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.awsRegion]: {
    dataFieldName: cloudInsightsColumns.event.awsRegion,
    label: 'AWS region',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.sourceIpAddress]: {
    dataFieldName: cloudInsightsColumns.event.sourceIpAddress,
    label: 'Source IP',
    width,
  },
  [cloudInsightsColumns.event.userAgent]: {
    dataFieldName: cloudInsightsColumns.event.userAgent,
    label: 'User agent',
    width,
  },
  [cloudInsightsColumns.event.errorCode]: {
    dataFieldName: cloudInsightsColumns.event.errorCode,
    label: 'Error code',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.errorMessage]: {
    dataFieldName: cloudInsightsColumns.event.errorMessage,
    label: 'Error Message',
    width,
  },
  [cloudInsightsColumns.event.requestParameters]: {
    dataFieldName: cloudInsightsColumns.event.requestParameters,
    getJson: (event) => event.event.requestParameters,
    label: 'Request Parameters',
    width,
  },
  [cloudInsightsColumns.event.responseElements]: {
    dataFieldName: cloudInsightsColumns.event.responseElements,
    getJson: (event) => event.event.responseElements,
    label: 'Response elements',
    width,
  },
  [cloudInsightsColumns.event.additionalEventData]: {
    dataFieldName: cloudInsightsColumns.event.additionalEventData,
    getJson: (event) => event.event.additionalEventData,
    label: 'Additional data',
    width,
  },
  [cloudInsightsColumns.event.requestId]: {
    dataFieldName: cloudInsightsColumns.event.requestId,
    label: 'Request ID',
    width,
  },
  [cloudInsightsColumns.event.eventId]: {
    dataFieldName: cloudInsightsColumns.event.eventId,
    label: 'Event ID',
    width,
  },
  [cloudInsightsColumns.event.readOnly]: {
    dataFieldName: cloudInsightsColumns.event.readOnly,
    label: 'Read only',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.resources]: {
    dataFieldName: cloudInsightsColumns.event.resources,
    getJson: (event) => event.event.resources,
    label: 'Resources',
    width,
  },
  [cloudInsightsColumns.event.resourcesArnPrefix]: {
    dataFieldName: cloudInsightsColumns.event.resourcesArnPrefix,
    label: 'Resource ARN Prefix',
    width,
  },
  [cloudInsightsColumns.event.resourcesAccountId]: {
    dataFieldName: cloudInsightsColumns.event.resourcesAccountId,
    label: 'Resource AccountId',
    width,
  },
  [cloudInsightsColumns.event.resourcesType]: {
    dataFieldName: cloudInsightsColumns.event.resourcesType,
    label: 'Resource Type',
    width,
  },
  [cloudInsightsColumns.event.eventType]: {
    dataFieldName: cloudInsightsColumns.event.eventType,
    label: 'Event type',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.apiVersion]: {
    dataFieldName: cloudInsightsColumns.event.apiVersion,
    label: 'API version',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.managementEvent]: {
    dataFieldName: cloudInsightsColumns.event.managementEvent,
    label: 'Management event?',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.recipientAccountId]: {
    dataFieldName: cloudInsightsColumns.event.recipientAccountId,
    label: 'Recipient account',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.sharedEventId]: {
    dataFieldName: cloudInsightsColumns.event.sharedEventId,
    label: 'Shared Event ID',
    width,
  },
  [cloudInsightsColumns.event.vpcEndpointId]: {
    dataFieldName: cloudInsightsColumns.event.vpcEndpointId,
    label: 'VPC endpoint',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.serviceEventDetails]: {
    dataFieldName: cloudInsightsColumns.event.serviceEventDetails,
    getJson: (event) => event.event.serviceEventDetails,
    label: 'Service Event',
    width,
  },
  [cloudInsightsColumns.event.addendum]: {
    dataFieldName: cloudInsightsColumns.event.addendum,
    getJson: (event) => event.event.addendum,
    label: 'Addendum',
    width,
  },
  [cloudInsightsColumns.event.edgeDeviceDetails]: {
    dataFieldName: cloudInsightsColumns.event.edgeDeviceDetails,
    getJson: (event) => event.event.edgeDeviceDetails,
    label: 'Edge Device',
    width,
  },
  [cloudInsightsColumns.event.eventCategory]: {
    dataFieldName: cloudInsightsColumns.event.eventCategory,
    label: 'Event Category',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.event.tlsDetails]: {
    dataFieldName: cloudInsightsColumns.event.tlsDetails,
    getJson: (event) => event.event.tlsDetails,
    label: 'TLS details',
    width,
  },
  [cloudInsightsColumns.event.sessionCredentialFromConsole]: {
    dataFieldName: cloudInsightsColumns.event.sessionCredentialFromConsole,
    label: 'Session from console?',
    sortable: true,
    width,
  },
  [cloudInsightsColumns.nonPersonEntity]: {
    dataFieldName: cloudInsightsColumns.nonPersonEntity,
    label: 'Non-Person Entity',
    width,
  },
};

export const defaultColumnsData = [
  columnDataMap[cloudInsightsColumns.expandButton],
  columnDataMap[cloudInsightsColumns.eventTime],
  columnDataMap[cloudInsightsColumns.connector],
  columnDataMap[cloudInsightsColumns.identity],
  columnDataMap[cloudInsightsColumns.eventName],
  columnDataMap[cloudInsightsColumns.event.resourcesArn],
];

export const additionalColumnsData = [
  columnDataMap[cloudInsightsColumns.event.eventVersion],
  columnDataMap[cloudInsightsColumns.event.userIdentity.type],
  columnDataMap[cloudInsightsColumns.event.userIdentity.principalId],
  columnDataMap[cloudInsightsColumns.event.userIdentity.arn],
  columnDataMap[cloudInsightsColumns.event.userIdentity.accountId],
  columnDataMap[cloudInsightsColumns.event.userIdentity.accessKeyId],
  columnDataMap[cloudInsightsColumns.event.userIdentity.sessionContext.sessionIssuer],
  columnDataMap[cloudInsightsColumns.event.userIdentity.invokedBy],
  columnDataMap[cloudInsightsColumns.event.userIdentity.userName],
  columnDataMap[cloudInsightsColumns.event.userIdentity.identityProvider],
  columnDataMap[cloudInsightsColumns.event.eventSource],
  columnDataMap[cloudInsightsColumns.event.awsRegion],
  columnDataMap[cloudInsightsColumns.event.sourceIpAddress],
  columnDataMap[cloudInsightsColumns.event.userAgent],
  columnDataMap[cloudInsightsColumns.event.errorCode],
  columnDataMap[cloudInsightsColumns.event.errorMessage],
  columnDataMap[cloudInsightsColumns.event.requestParameters],
  columnDataMap[cloudInsightsColumns.event.responseElements],
  columnDataMap[cloudInsightsColumns.event.additionalEventData],
  columnDataMap[cloudInsightsColumns.event.requestId],
  columnDataMap[cloudInsightsColumns.event.eventId],
  columnDataMap[cloudInsightsColumns.event.readOnly],
  columnDataMap[cloudInsightsColumns.event.resourcesAccountId],
  columnDataMap[cloudInsightsColumns.event.resourcesArnPrefix],
  columnDataMap[cloudInsightsColumns.event.resourcesType],
  columnDataMap[cloudInsightsColumns.event.eventType],
  columnDataMap[cloudInsightsColumns.event.apiVersion],
  columnDataMap[cloudInsightsColumns.event.managementEvent],
  columnDataMap[cloudInsightsColumns.event.recipientAccountId],
  columnDataMap[cloudInsightsColumns.event.sharedEventId],
  columnDataMap[cloudInsightsColumns.event.vpcEndpointId],
  columnDataMap[cloudInsightsColumns.event.serviceEventDetails],
  columnDataMap[cloudInsightsColumns.event.addendum],
  columnDataMap[cloudInsightsColumns.event.edgeDeviceDetails],
  columnDataMap[cloudInsightsColumns.event.eventCategory],
  columnDataMap[cloudInsightsColumns.event.tlsDetails],
  columnDataMap[cloudInsightsColumns.event.sessionCredentialFromConsole],
  columnDataMap[cloudInsightsColumns.nonPersonEntity],
  columnDataMap[cloudInsightsColumns.accountId],
];

export const csvData = [
  columnDataMap[cloudInsightsColumns.eventTime],
  columnDataMap[cloudInsightsColumns.accountId],
  columnDataMap[cloudInsightsColumns.connector],
  columnDataMap[cloudInsightsColumns.event.userIdentity.type],
  columnDataMap[cloudInsightsColumns.event.userIdentity.userName],
  columnDataMap[cloudInsightsColumns.event.userIdentity.principalId],
  columnDataMap[cloudInsightsColumns.event.userIdentity.arn],
  columnDataMap[cloudInsightsColumns.event.userIdentity.accountId],
  columnDataMap[cloudInsightsColumns.event.userIdentity.accessKeyId],
  columnDataMap[cloudInsightsColumns.event.userIdentity.sessionContext.sessionIssuer],
  columnDataMap[cloudInsightsColumns.event.userIdentity.invokedBy],
  columnDataMap[cloudInsightsColumns.event.userIdentity.identityProvider],
  columnDataMap[cloudInsightsColumns.event.eventSource],
  columnDataMap[cloudInsightsColumns.eventName],
  columnDataMap[cloudInsightsColumns.event.awsRegion],
  columnDataMap[cloudInsightsColumns.event.sourceIpAddress],
  columnDataMap[cloudInsightsColumns.event.userAgent],
  columnDataMap[cloudInsightsColumns.event.errorCode],
  columnDataMap[cloudInsightsColumns.event.errorMessage],
  columnDataMap[cloudInsightsColumns.event.requestParameters],
  columnDataMap[cloudInsightsColumns.event.responseElements],
  columnDataMap[cloudInsightsColumns.event.additionalEventData],
  columnDataMap[cloudInsightsColumns.event.requestId],
  columnDataMap[cloudInsightsColumns.event.eventId],
  columnDataMap[cloudInsightsColumns.event.readOnly],
  columnDataMap[cloudInsightsColumns.event.resources],
  columnDataMap[cloudInsightsColumns.event.eventType],
  columnDataMap[cloudInsightsColumns.event.apiVersion],
  columnDataMap[cloudInsightsColumns.event.managementEvent],
  columnDataMap[cloudInsightsColumns.event.recipientAccountId],
  columnDataMap[cloudInsightsColumns.event.sharedEventId],
  columnDataMap[cloudInsightsColumns.event.vpcEndpointId],
  columnDataMap[cloudInsightsColumns.event.serviceEventDetails],
  columnDataMap[cloudInsightsColumns.event.addendum],
  columnDataMap[cloudInsightsColumns.event.edgeDeviceDetails],
  columnDataMap[cloudInsightsColumns.event.eventCategory],
  columnDataMap[cloudInsightsColumns.event.tlsDetails],
  columnDataMap[cloudInsightsColumns.event.sessionCredentialFromConsole],
];

export const columnsData = [
  ...defaultColumnsData,
  ...additionalColumnsData,
];

// eslint-disable-next-line max-len
export const eventFields = columnsData.reduce((obj, column) => ({ ...obj, [column.label]: column.label }), {});

export const routeConsts = {
  cloudInsightsAccounts: 'cloudInsightsAccounts',
  cloudInsightsMain: 'cloudInsightsMain',
};

export const routeNames = {
  [routeConsts.cloudInsightsAccounts]: 'CloudInsightsAccounts',
  [routeConsts.cloudInsightsMain]: 'CloudInsightsMain',
};

// Flattens the nested object
// SEE: https://stackoverflow.com/questions/33036487/one-liner-to-flatten-nested-object
export function flattenObject(obj, roots = [], sep = '.') {
  return Object
    .keys(obj)
    .reduce((memo, prop) => ({
      ...memo,
      ...(Object.prototype.toString.call(obj[prop]) === '[object Object]'
        ? flattenObject(obj[prop], roots.concat([prop]), sep)
        : { [roots.concat([prop]).join(sep)]: obj[prop] }),
    }), {});
}

export const optionalFilters = [
  columnDataMap[cloudInsightsColumns.event.awsRegion],
  columnDataMap[cloudInsightsColumns.event.eventCategory],
  columnDataMap[cloudInsightsColumns.event.eventSource],
  columnDataMap[cloudInsightsColumns.event.userIdentity.accountId],
  columnDataMap[cloudInsightsColumns.event.userIdentity.type],
  columnDataMap[cloudInsightsColumns.event.userIdentity.invokedBy],
  columnDataMap[cloudInsightsColumns.event.userIdentity.principalId],
  columnDataMap[cloudInsightsColumns.event.readOnly],
  columnDataMap[cloudInsightsColumns.event.resourcesAccountId],
  columnDataMap[cloudInsightsColumns.event.resourcesArnPrefix],
  columnDataMap[cloudInsightsColumns.event.resourcesArn],
  columnDataMap[cloudInsightsColumns.event.resourcesType],
  columnDataMap[cloudInsightsColumns.event.recipientAccountId],
];

export const primaryFilters = [
  columnDataMap[cloudInsightsColumns.accountId],
  columnDataMap[cloudInsightsColumns.connector],
  columnDataMap[cloudInsightsColumns.event.userIdentity.userName],
  columnDataMap[cloudInsightsColumns.eventName],
];

export default {
  cloudInsightsColumns,
  columnsData,
  eventFields,
  optionalFilters,
  primaryFilters,
  routeConsts,
  routeNames,
};
